export default class Item {
	constructor(
		valor=0,
        desconto=0,
        descricao='',
        pedido_id='',
        produto_id='',
        estagio_id='',
        quantidade=1
	){
		this.valor = valor;
        this.desconto = desconto;
        this.descricao = descricao;
        this.pedido_id = pedido_id;
        this.produto_id = produto_id;
        this.estagio_id = estagio_id;
        this.quantidade = quantidade;
	}
}